<form action="">
  <ng-template ngFor let-star [ngForOf]="stars" let-i="index">
    <input #ngxCheckbox class="star star-{{ star }}" id="star-{{ star }}-{{ id }}" type="radio" name="star" (click)="rate(star)"
      [checked]="value == star" [disabled]="disabled" />
    <label class="star star-{{ star }}" for="star-{{ star }}-{{ id }}"></label>
  </ng-template>
</form>
